import { makeRequest } from "../lib/makeRequest";

const constructArrayParams = (data) => {
  const arrayParams = new URLSearchParams();
  arrayParams.append("month", data.month);
  arrayParams.append("year", data.year);
  arrayParams.append("limit", 10);
  return arrayParams;
};

export const previous_month_average_cluster_v4 = (data) => {
  const arrayParams = constructArrayParams(data);
  data.cluster_ids.forEach((cluster_id) =>
    arrayParams.append("clusterIds", cluster_id)
  );
  return makeRequest(
    `/previous-month-averages/clusters?${arrayParams.toString()}`
  );
};

export const previous_month_average_area_v4 = (data) => {
  return makeRequest(
    `/previous-month-averages/areas?${constructArrayParams(data)}`,
    data.area_codes,
    "post"
  );
};

export const previous_month_average_branch_v4 = (data) =>
  makeRequest(
    `/previous-month-averages/branches?${constructArrayParams(data)}`,
    data.branch_codes,
    "post"
  );
